import { render, staticRenderFns } from "./DeploySuccessCard.vue?vue&type=template&id=86480988&scoped=true"
import script from "./DeploySuccessCard.vue?vue&type=script&lang=ts"
export * from "./DeploySuccessCard.vue?vue&type=script&lang=ts"
import style0 from "./DeploySuccessCard.vue?vue&type=style&index=0&id=86480988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86480988",
  null
  
)

export default component.exports